<div class="atmos-toolbar" data-step="100" data-position="bottom-left-aligned">
  <div class="atmos-toolbar__row atmos-toolbar__row--actions">
    @if (!isRequesting()) {
      <!-- Show my/all items -->
      <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleCloset()" data-step="101">
        <mat-icon>checkroom</mat-icon>
        <span>{{ state.closetMode() === 'all' ? 'My items' : 'All items' }}</span>
      </button>
      <!-- Modify closet -->
      <button type="button" class="atmos-btn atmos-btn--sm" [class.atmos-btn--active]="state.modifyingCloset()" (click)="modifyCloset()" data-step="102" data-position="bottom-left-aligned">
        <mat-icon>manufacturing</mat-icon>
        <span>Modify</span>
      </button>
    }
    <!-- Icon size -->
    <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleItemSize()" data-step="122" data-position="bottom-left-aligned">
      <mat-icon>{{ state.itemSize() === 'small' ? 'zoom_in' : 'zoom_out' }}</mat-icon>
      <span>{{ state.itemSize() === 'small' ? 'Large icons' : 'Small icons' }}</span>
    </button>
    @if (!isRequesting()) {
      <!-- IAP toggle -->
      <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleIap()" data-step="123" data-position="bottom-left-aligned">
        <mat-icon>{{ state.hideIap() ? 'attach_money' : 'money_off' }}</mat-icon>
        <span>{{ state.hideIap() ? 'Show IAP' : 'Hide IAP' }}</span>
      </button>
    }
    <!-- Background -->
    <button type="button" class="atmos-btn atmos-btn--sm" [class.atmos-btn--active]="state.showingBackgroundPicker()" (click)="showBackgroundPicker($event)" data-step="128" data-position="bottom-left-aligned">
      <mat-icon>wallpaper</mat-icon>
      <span>Background</span>
    </button>
    <!-- Reset -->
    <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="resetRequest.emit()" data-step="124" data-position="bottom-left-aligned">
      <mat-icon>delete_forever</mat-icon>
      <span>Reset</span>
    </button>
    <!-- Random -->
    <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="randomRequest.emit()" data-step="125" data-position="bottom-left-aligned">
      <mat-icon>shuffle</mat-icon>
    </button>
    <!-- Calculate cost -->
    <button type="button" class="atmos-btn atmos-btn--sm" (click)="calculateCostRequest.emit()" data-step="127" data-position="bottom-left-aligned">
      <mat-icon>calculate</mat-icon>
      <span>Costs</span>
    </button>
    <!-- Tour -->
    <button type="button" class="atmos-btn atmos-btn--sm" (click)="startTourRequest.emit()">
      <mat-icon>explore</mat-icon>
      <span>Tour</span>
    </button>
  </div>

  <div class="atmos-toolbar__row atmos-toolbar__row--search">
    <!-- Search -->
    <div class="atmos-search" data-step="126" data-position="bottom-left-aligned">
      <mat-icon class="atmos-search__icon">search</mat-icon>
      <input class="atmos-input atmos-search__field" type="search" placeholder="Search items…"
        (input)="search($any($event.target).value)" />
    </div>

    <!-- Color picker -->
    <div class="atmos-color-picker" data-step="3" data-position="bottom-right-aligned">
      <button type="button" class="atmos-color-btn atmos-color-btn--active"
        [class.atmos-color-btn--r]="state.color() === 'r'"
        [class.atmos-color-btn--y]="state.color() === 'y'"
        [class.atmos-color-btn--g]="state.color() === 'g'"
        [class.atmos-color-btn--b]="state.color() === 'b'"
        (click)="toggleColorPicker($event)">
        <mat-icon>border_color</mat-icon>
      </button>
      @if (state.showingColorPicker()) {
        <div class="atmos-color-picker__dropdown">
          <button type="button" class="atmos-color-btn atmos-color-btn--r atmos-color-btn--fill" (click)="setColor('r')"></button>
          <button type="button" class="atmos-color-btn atmos-color-btn--y atmos-color-btn--fill" (click)="setColor('y')"></button>
          <button type="button" class="atmos-color-btn atmos-color-btn--g atmos-color-btn--fill" (click)="setColor('g')"></button>
          <button type="button" class="atmos-color-btn atmos-color-btn--b atmos-color-btn--fill" (click)="setColor('b')"></button>
          <button type="button" class="atmos-color-btn" (click)="setColor(undefined)"><mat-icon>delete</mat-icon></button>
        </div>
      }
    </div>
  </div>
</div>
